import React, { useState, useEffect, useLayoutEffect } from 'react';
import IndexCarousel from '../main/IndexCarousel';
import '../main/submenulist.scss';
import ApiSurvey from '../../api/survey';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { useHistory } from 'react-router-dom';
import { StaticImage } from '../../utils/image';
// import YoutuberPlayer from "./react-player/YoutuberPlayer";
import { fade, makeStyles } from '@material-ui/core';
// import SurveyCard from './newLayout/index';
import SurveyCardMobile from '../listening/newLayoutMobile';
import { checkUser } from '../../utils/checkUser';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import ApiMaster from '../../api/master';
import { useWindowSize } from '../../utils/WindowSize';
import SurveyCardV2 from './desktop/survey';
import ProjectCardV2 from './desktop/project';
import SurveyCardV2Mobile from './mobile/survey';
import ProjectCardV2Mobile from './mobile/project';
import './index.scss';


const useStylesAvatar = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    borderRadius: '100px',
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    backgroundColor: '#e5e6ee',
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),

    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: '40ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

const scoreText = [
  { value: "send", label: "#ตอบ", color: "#a51830" },
  { value: "draft", label: "#ทำต่อ", color: "#387436" },
];

const ListeningPageindex = () => {
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [retry, setRetry] = useState(0);
  const [surveys, setsurveys] = useState([]);
  const [surveyFilter, setSurveyFilter] = useState([]);
  const [card_type, setcard_type] = useState('send');
  const history = useHistory();
  const classes = useStyles();
  const classAvatar = useStylesAvatar();
  const userState = useSelector((state) => state.user);
  const [projects, setprojects] = useState([]);
  const [entitys, setEntitys] = useState([]);
  const [process, setprocess] = useState([]);
  const [law_group, setlawgroup] = useState([]);
  const [agencyOption, setAgencyOption] = useState([
    { value: null, label: "ทั้งหมด" },
  ]);
  const [ministryOption, setMinistryOption] = useState([
    { value: null, label: "ทั้งหมด" },
  ]);
  const [surveyTypeOption, setSurveyTypeOption] = useState([
    { value: null, label: "ทั้งหมด" },
  ]);
  useEffect(() => {
    let live = true;
    setLoading(true);
    setLoadError('');
    Promise.all([ApiSurvey.historyV2(), ApiMaster.homeFilter()]).then(([survey, filter]) => {
      if (!live) return;
      if (survey.status !== 200 || filter.status !== 200) throw new Error('history');
      const body = survey.data || {};
      const rows = Array.isArray(body.data) ? body.data.filter(row => row && typeof row === 'object') : [];
      setsurveys(rows);
      setSurveyFilter(rows);
      setlawgroup(Array.isArray(body.law_group) ? body.law_group : []);
      setEntitys(Array.isArray(body.entitys) ? body.entitys : []);
      const options = filter.data?.data || {};
      setAgencyOption([{ value: null, label: "ทั้งหมด" }, ...(Array.isArray(options.agency) ? options.agency : [])]);
      setMinistryOption([{ value: null, label: "ทั้งหมด" }, ...(Array.isArray(options.ministry) ? options.ministry : [])]);
      setSurveyTypeOption([{ value: null, label: "ทั้งหมด" }, ...(Array.isArray(options.survey_type) ? options.survey_type : []).filter(x => x.label !== "หลักการ" && x.label !== "ร่างกม.โดยผู้พิจารณา")]);
    }).catch(() => { if (live) setLoadError('ไม่สามารถโหลดประวัติการตอบแบบสอบถามได้'); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [retry]);

  // useEffect(() => {
  //   getOrderSurvey({ orderFilter: card_type })
  //   return () => {
  //   }
  // }, [card_type])



  const getFilterSurvey = async ({
    ministry,
    agency,
    surveyType,
    statusSurvey,
    searchFilter,
  }) => {
    let survey = [...surveys];
    if (ministry > 0) {
      survey = survey.filter((x) => x.ministry_id == ministry);
    }

    if (agency > 0) {
      survey = survey.filter((x) => x.agency_id == agency);
    }
    if (surveyType > 0) {
      if (surveyType == 2) {
        survey = survey.filter(
          (x) => x.survey_type_id == 1 || x.survey_type_id == 2
        );
      } else {
        survey = survey.filter((x) => x.survey_type_id == surveyType);
      }
    }
    if (statusSurvey == 'O') {
      survey = survey.filter(
        (x) => (x.isconclude == 'O' || !x.isconclude) && x.date_balance >= 0
      );
    } else if (statusSurvey == 'I') {
      survey = survey.filter(
        (x) =>
          x.date_balance < 0 ||
          x.isconclude == 'D' ||
          x.isconclude == 'C' ||
          x.isconclude == 'B' ||
          x.isconclude == 'P'
      );
    }
    if (searchFilter) {
      if (card_type == "progress") {
        survey = survey.filter(item => {
          return (
            String(item.project?.project_name || '').includes(searchFilter)
          )
        });
      } else {
        survey = survey.filter(item => {
          return (
            String(item.short_survey_name || '').includes(searchFilter) || String(item.survey_name || '').includes(searchFilter) ||
            String(item.short_project_name || '').includes(searchFilter) || String(item.project_name || '').includes(searchFilter)
          )
        });
      }

    }

    setSurveyFilter(survey);
  };

  const getOrderSurvey = async ({ orderFilter }) => {
    let survey = [...surveys];

    if (orderFilter == 'last') {
      survey = _.orderBy(surveyFilter, 'created_date', 'desc');
    } else if (orderFilter == 'answer') {
      survey = _.orderBy(
        surveyFilter,
        [
          (o) => {
            return o.answer_count || '';
          },
        ],
        ['desc']
      );
    } else if (orderFilter == 'read') {
      survey = _.orderBy(
        surveyFilter,
        [
          (o) => {
            return o.view_count || '';
          },
        ],
        ['desc']
      );
    } else if (orderFilter == 'popular') {
      survey = _.orderBy(
        surveyFilter,
        [
          (o) => {
            return o.view_count || '';
          },
        ],
        ['desc']
      );
    }

    setSurveyFilter(survey);
  };

  const handleFavorite = async (e, item) => {
    e.stopPropagation();
    if (checkUser(userState)) {
      const model = {
        project_id: item.project_id,
      };
      try {
        const result = await ApiSurvey.favoriteProject(model);
        if (result.status == 200) {
          //filter
          const likesFilter = [...surveyFilter];
          const indexFilter = likesFilter.findIndex(
            (x) => parseInt(x.project_id) == item.project_id
          );
          likesFilter[indexFilter].is_like = !likesFilter[indexFilter].is_like;

          setSurveyFilter(likesFilter);
        }
      } catch (error) {
        console.log(error);
        Swal.close();
      }
    }
  };

  return (
    // <Container maxWidth="xl">
    <div id="listening-v2" className='container-fluid bg-white'>
      <div>
        <section className='section-banner' style={{}}>
          <IndexCarousel history={history} />
        </section>
      </div>
      <div className="d-flex-align-center" style={{
        paddingLeft: '8%',
        paddingRight: '8%',
        marginTop: width >= 768 ? 0 : 50,
        zoom: width >= 768 ? '100%' : '80%'
      }}>
        <span style={{ marginRight: 15, fontSize: 18, whiteSpace: 'nowrap' }} className="text-primary text-regular">มุมมอง</span>
        {scoreText.map((item) => {
          return (
            <div
              style={{
                backgroundColor:
                  card_type == item.value ? '#fff' : "#e5e6ee",
              }}
              className="card-type-filter"
              onClick={() => setcard_type(item.value)}>
              <span className="text-regular" style={{ color: item.color }}>{item.label}</span>
            </div>
          )
        })}
      </div>
      {loading && <p role="status" className="py-10 text-center">กำลังโหลดประวัติ…</p>}
      {loadError && <p role="alert" className="py-10 text-center">{loadError} <button onClick={() => setRetry(value => value + 1)}>ลองใหม่อีกครั้ง</button></p>}
      {!loading && !loadError && !surveyFilter.some(row => row.type === card_type) && <p role="status" className="py-10 text-center">{surveys.length ? "ไม่พบประวัติตามเงื่อนไขที่เลือก" : "ยังไม่มีประวัติการตอบแบบสอบถาม"}</p>}
      {
        !loading && !loadError && width >= 768 && (
          <section>
            <SurveyCardV2
              agencyOption={agencyOption}
              ministryOption={ministryOption}
              surveyTypeOption={surveyTypeOption}
              getFilterSurvey={getFilterSurvey}
              handleFavorite={handleFavorite}
              law_group={law_group}
              surveys={surveyFilter.filter(x => x.type == card_type)}
              entitys={entitys} />
          </section>
        )
      }
      {
        !loading && !loadError && width < 768 && (
          <section>
            <SurveyCardV2Mobile
              agencyOption={agencyOption}
              ministryOption={ministryOption}
              surveyTypeOption={surveyTypeOption}
              getFilterSurvey={getFilterSurvey}
              handleFavorite={handleFavorite}
              law_group={law_group}
              surveys={surveyFilter.filter(x => x.type == card_type)}
              entitys={entitys} />
          </section>

        )
      }
    </div >
  );
};

export default ListeningPageindex;
